// extracted by mini-css-extract-plugin
module.exports = {"board_state_wrapper":"BoardState_board_state_wrapper__1gC9q"};